<template>
  <div>
    <el-row style="text-align:left;margin-top:10px;margin-bottom:10px">
      <el-col :span="24">
        <el-col :span="4" :offset="0">
          <!-- +新增 -->
          <el-button type="p0332Button" plain @click="openDialog()">{{
            "+" + $t("common.new")
          }}</el-button>
          <el-dialog
            class="roll-dialog"
            :title="$t('p0201.companyUserInfo')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="70%"
            center
          >
            <emp-add
              ref="empAdd"
              :getUser="getUserDetail"
              :closeDialog="closeDialog"
              :mCompanyId="mCompanyId"
            ></emp-add> </el-dialog
        ></el-col>
      </el-col>
      <br
    /></el-row>
    <el-row>
      <el-col>
        <el-table
          ref="userDetailTable"
          :data="companyStaffData"
          v-loading="pageLoading"
          tooltip-effect="dark"
        >
          <!-- 姓名-->
          <el-table-column :label="$t('p0212.userName')" align="center">
            <template slot-scope="scope">
              {{ scope.row.lastName + " " + scope.row.firstName }}
            </template>
          </el-table-column>
          <!-- 英文姓名 -->
          <el-table-column :label="$t('p0212.englishName')" align="center">
            <template slot-scope="scope">
              {{
                scope.row.lastNameEn == null && scope.row.firstNameEn == null
                  ? ""
                  : scope.row.lastNameEn + " " + scope.row.firstNameEn
              }}
            </template>
          </el-table-column>
          <!-- 昵称 -->
          <el-table-column
            prop="nickName"
            :label="$t('p0212.nickname')"
            align="center"
          ></el-table-column>

          <!-- 邮箱 -->
          <el-table-column
            prop="email"
            :label="$t('p0201companyUserInfo.email')"
            align="center"
            width="200px"
          ></el-table-column>
          <!-- 手机 -->
          <el-table-column
            :label="$t('p0201companyUserInfo.phoneNo')"
            align="center"
            width="150px"
          >
            <template slot-scope="scope">{{
              scope.row.phoneArea + scope.row.phoneNo !== 0
                ? scope.row.phoneArea + scope.row.phoneNo
                : ""
            }}</template>
          </el-table-column>
          <!-- 头像 -->
          <el-table-column :label="$t('p0212.headPortrait')" align="center">
            <template slot-scope="scope">
              <el-avatar
                :src="viewHeadPortrait(scope.row.headPortrait)"
                :key="scope.row.headPortrait"
                :size="30"
              ></el-avatar>
            </template>
          </el-table-column>
          <!-- 部门 -->
          <el-table-column
            prop="position"
            :label="$t('p0201companyUserInfo.department')"
            align="center"
          ></el-table-column>
          <!-- 职位 -->
          <el-table-column
            prop="department"
            :label="$t('p0201companyUserInfo.position')"
            align="center"
          ></el-table-column>
          <!-- 注册日期 -->
          <el-table-column
            prop="createTime"
            :formatter="registerDateFormat"
            :label="$t('p0201companyUserInfo.registerDate')"
            align="center"
          ></el-table-column>
          <!-- 操作 -->
          <el-table-column :label="$t('p0212.operate')" align="center">
            <template slot-scope="scope">
              <!-- 详情 -->
              <el-button
                size="mini"
                type="text"
                @click="
                  detail(
                    scope.row,
                    scope.row.userId,
                    scope.row.documentAppendix01,
                    scope.row.documentAppendix02
                  )
                "
                >&nbsp;{{ $t("p0212.details") }}</el-button
              >
              <!-- 删除 -->
              <el-button size="mini" type="text" @click="handleDel(scope.row)"
                >&nbsp;{{ $t("common.delete") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <el-row style="text-align: right; margin: 20px">
      <el-col :span="24">
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-row><br /><br /></el-row>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import empAdd from "../CustomerInfoBase/P0206";
export default {
  name: "demo",
  components: {
    empAdd
  },
  data() {
    let p0202 = JSON.parse(sessionStorage.getItem("p0202"));
    return {
      dialogVisible: false,
      // 公司ID
      mCompanyId: p0202.mCompanyId,
      // 个人用户一览
      companyStaffData: [],
      // 页面载入状态
      pageLoading: false,
      // 当前页
      currentPage: 1,
      // 每页件数
      pageSize: 20,
      total: 0,
      // 默认头像图片
      defaultImg: require("../../assets/headPortrait.png")
    };
  },
  mounted() {
    if (sessionStorage.getItem("detail")) {
      this.getSchoolWebModuleMessageListFunc();
    } else {
      this.getUserDetail(true);
    }
  },
  methods: {
    // 打开dialog
    openDialog() {
      this.dialogVisible = true;
      this.$nextTick(function() {
        this.$refs.empAdd.tmpQueryStr = "";
        this.$refs.empAdd.queryForm.queryCriteria = "";
        this.$refs.empAdd.getUserDetail(true);
        this.$refs.empAdd.init();
      });
    },
    // 关闭dialog
    closeDialog() {
      this.dialogVisible = false;
    },
    // 删除用户
    handleDel(row) {
      // 是否删除该用户？
      this.$confirm(this.$t("p0205.deleteThisUser"), {
        // 确定
        confirmButtonText: this.$t("common.confirm"),
        // 取消
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      })
        .then(() => {
          console.log(
            "🚀 ~ file: P0205.vue ~ line 174 ~ .then ~ this.mCompanyId",
            this.mCompanyId
          );
          let url = "/api/companyOrganizationCustomers/deleteCompanyPersonnel";
          this.$http
            .post(
              url,
              qs.stringify({
                userId: row.userId,
                mCompanyId: this.mCompanyId
              })
            )
            .then(response => {
              if ((response.data.code = 200)) {
                // 删除成功
                this.$message.success(this.$t("common.deletedSuccessfully"));
                this.getUserDetail();
                return;
              }
            })
            .catch(err => {
              this.$message.error(err);
            });
        })
        .catch(() => {});
    },
    //TQS注册日期格式化时间
    registerDateFormat(row) {
      if (row.createTime != null && row.createTime != "") {
        return moment(row.createTime).format("YYYY-MM-DD");
      }
    },
    // 公司人员基本信息初始化
    getUserDetail(val) {
      this.pageLoading = true;
      if (val) {
        this.currentPage = 1;
        this.total = 0;
      }
      let url = "/api/companyOrganizationCustomers/companyPersonnelInformation";
      this.$http
        .post(
          url,
          qs.stringify({
            mCompanyId: this.mCompanyId,
            currentSize: (this.currentPage - 1) * this.pageSize,
            pageSize: this.pageSize,
            total: this.total
          })
        )
        .then(response => {
          this.pageLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            if (response.data.data.length == 0) {
              return;
            }
            this.companyStaffData = response.data.data;
            //判断是否初始化
            if (this.currentPage == 1) {
              this.companyStaffData = response.data.data;
              this.total = this.companyStaffData[0].total;
            } else {
              this.companyStaffData = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.pageLoading = false;
          this.$message.error(err);
        });
    },
    // 个人用户详细信息取得
    detail(idx, userId) {
      // alert("功能开发中，请耐心等待！");
      let p0212 = JSON.stringify({
        userID: userId,
        locationCode1: idx.documentAppendix01,
        locationCode2: idx.documentAppendix02,
        currentPage: this.currentPage,
        imageBase64: idx.headPortrait
      });
      sessionStorage.p0212 = p0212;
      sessionStorage.setItem("total", this.total);
      sessionStorage.setItem("pageSize", this.pageSize);
      console.log("total", this.total);
      console.log("pageSize", this.pageSize);
      // console.log("p0212"+p0212)
      // 跳转指定页面
      this.$router.push({
        path: "/views/CustomerInfoBase/P0213"
      });
    },
    // 头像图片显示
    viewHeadPortrait(imgCodeStr) {
      return imgCodeStr == null
        ? this.defaultImg
        : "data:image/png;base64," + imgCodeStr;
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;

      //判断更改页码是否需要查询
      if (
        this.companyStaffData == undefined ||
        this.companyStaffData.length <= 0
      ) {
        return;
      }
      this.getUserDetail(false);
      console.log(`每页 ${val} 条`);
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserDetail(false);
      console.log(`当前页: ${val}`);
    },
    //返回跳转前的页面
    getSchoolWebModuleMessageListFunc() {
      //当从详情页返回的时候，先获取详情页中存下来的detall标识，在列表页中，把获取到的分页页码重新赋值，用以返回前的页面，保持不变
      if (sessionStorage.getItem("detail")) {
        //如果有这个就读取缓存里面的数据
        this.currentPage = Number(sessionStorage.getItem("currentPage"));
        this.total = Number(sessionStorage.getItem("total"));
        this.pageSize = Number(sessionStorage.getItem("pageSize"));
        this.getUserDetail(false);
        sessionStorage.removeItem("detail");
      } else {
        this.currentPage = 1;
        //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
        sessionStorage.removeItem("currentPage");
        sessionStorage.removeItem("total");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
//弹窗样式
>>> .roll-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(90vh - 140px);
}
// 表格样式
>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

>>> .el-form-item__label {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table .cell {
  line-height: 30px;
  height: 30px;
}
>>> .el-table .el-table__cell {
  padding: 8.5px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0205.vue